import axios from 'axios';
import config from '../config';
import { store } from '../store';

const FeedbackService = {
  async submit({
    shortCode,
    section,
    working_well,
    improve,
    is_bug_report,
    user_id,
    signals,
  }) {
    const { loginReducer } = store.getState();
    const { token } = loginReducer;

    const { data } = await axios.post(
      `${config.drmApiUrl || config.apiUrl}/${shortCode}/feedback`,
      {
        section,
        working_well,
        improve,
        is_bug_report,
        user_id,
        signals,
      },
      {
        withCredentials: true,
        headers: token
          ? {
              Authorization: `Bearer ${token}`,
            }
          : undefined,
      },
    );

    return data;
  },
};

export default FeedbackService;
